export default "__VITE_ASSET__cd6ee15a__"